























































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import UserAvatar from '@/modules/shared/components/UserAvatar'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import ConfirmDialog from '@/modules/shared/components/ConfirmDialog'
import { ResponseStatus, TournamentAPI } from '@/api/tournament'
import {
  TournamentTeamEntity,
  TournamentPlayerEntity,
  TournamentTeamRole
} from '@/api/tournamentTeam'

@Component({
  components: {
    UserAvatar,
    ConfirmDialog
  }
})
export default class TournamentTeamChangeCaptainDialog extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  @PropSync('visible', { default: false }) isVisible!: boolean

  newCaptainMemberId: string = ''
  newCaptainMemberName: string = ''
  isConfirmDialogVisible: boolean = false
  isChangeCaptainLoading: boolean = false

  /* Watchers */
  @Watch('isVisible')
  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.newCaptainMemberId = ''
      this.newCaptainMemberName = ''
    }
  }

  /* Methods */
  onNewCaptainSelected(player: TournamentPlayerEntity) {
    this.newCaptainMemberId = player.memberId
    this.newCaptainMemberName = player.nickname
    this.isConfirmDialogVisible = true
  }

  isCurrentCaptain(player: TournamentPlayerEntity) {
    return player.role === TournamentTeamRole.Captain
  }

  async changeCaptain() {
    this.isChangeCaptainLoading = true
    try {
      const response = await TournamentAPI.changeTournamentTeamCaptain(
        this.selectedTournamentTeam!.tournamentTeamId,
        this.newCaptainMemberId
      )
      if (response.data.status === ResponseStatus.Ok) {
        this.$toast.success(
          this.$t(
            'TournamentTeamChangeCaptainDialog.TeamCaptainChangedSuccessfully'
          )
        )
        this.captainChanged()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Loading.SystemErrorMessage'))
      }

      console.error(err)
    } finally {
      this.isChangeCaptainLoading = false
      this.isConfirmDialogVisible = false
    }
  }

  captainChanged() {
    this.newCaptainMemberId = ''
    this.newCaptainMemberName = ''
    this.$emit('captainChanged')
  }

  /* Computed Properties */
  get selectedTournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get userId() {
    return this.userModule.userId
  }

  get isTeamCaptain(): boolean {
    let tournamentTeam = this.selectedTournamentTeam
    if (tournamentTeam && tournamentTeam.players) {
      return tournamentTeam.players.some(
        (player: TournamentPlayerEntity) =>
          player.memberId === this.userId && player.role === 'Captain'
      )
    }
    return false
  }

  get players(): TournamentPlayerEntity[] {
    if (!this.selectedTournamentTeam) return []
    return this.selectedTournamentTeam.players.filter(
      player => player.role !== TournamentTeamRole.RequestToJoin
    )
  }

  get confirmDialogMessage() {
    return this.$t(
      'TournamentTeamChangeCaptainDialog.ConfirmChangeTeamCaptainMessage',
      {
        captainName: this.newCaptainMemberName
      }
    )
  }
}
